import { render, staticRenderFns } from "./AppDateSince.vue?vue&type=template&id=7bcf17d4"
import script from "./AppDateSince.vue?vue&type=script&lang=js"
export * from "./AppDateSince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports